import React from "react";
import PullToRefresh from "../PullToRefresh";

/** Pull-to-refresh wrapper for the event guest list section. */
export default function GuestListPullToRefresh({ onRefresh, refreshing, children }) {
  return (
    <PullToRefresh
      onRefresh={onRefresh}
      refreshing={refreshing}
      testId="guest-list-pull-refresh"
    >
      {children}
    </PullToRefresh>
  );
}
